<template>
  <div class="pa-0">
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-form @submit.prevent="handleSubmit(submit)">
        <!-- Internal Toolbar for Tabs -->
        <v-tabs 
          v-model="tab"
          background-color="grey lighten-5"
          color="primary"
          grow
          class="border-bottom"
        >
          <v-tab class="text-none font-weight-bold py-4">
            <v-icon left small>fas fa-building</v-icon> Perfil Empresa
          </v-tab>
          <v-tab class="text-none font-weight-bold py-4">
            <v-icon left small>fas fa-file-invoice-dollar</v-icon> Compras / Ventas
          </v-tab>
          <v-tab class="text-none font-weight-bold py-4">
            <v-icon left small>fas fa-industry</v-icon> Producción
          </v-tab>
          <v-tab class="text-none font-weight-bold py-4">
            <v-icon left small>fas fa-chart-pie</v-icon> Dashboard
          </v-tab>
          <v-tab class="text-none font-weight-bold py-4">
            <v-icon left small>fas fa-server</v-icon> Sistema
          </v-tab>
          <v-tab class="text-none font-weight-bold py-4">
            <v-icon left small>fas fa-paper-plane</v-icon> Notificaciones
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <!-- 1. General Profile -->
          <v-tab-item class="pa-8">
            <v-row>
              <v-col cols="12" md="8">
                <div class="d-flex align-center mb-6">
                  <v-avatar size="32" color="primary lighten-5" class="mr-3">
                    <v-icon color="primary" small>fas fa-id-card</v-icon>
                  </v-avatar>
                  <span class="text-h6 font-weight-black primary--text">Información Legal y Comercial</span>
                </div>
                
                <v-row dense>
                  <v-col cols="12" md="6">
                    <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">{{ internacional.tax_id_label }}</div>
                    <v-text-field v-model='rut' outlined dense disabled class="modern-input opacity-70"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Razón Social</div>
                    <ValidationProvider name="Razón Social" rules="required" v-slot="{ errors }">
                      <v-text-field v-model='name' outlined dense :error-messages="errors" class="modern-input"></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Nombre de Fantasía</div>
                    <v-text-field v-model='fantasy' outlined dense class="modern-input"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Giro / Actividad</div>
                    <v-text-field v-model='giro' outlined dense class="modern-input"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Dirección Matriz</div>
                    <v-text-field v-model='address' outlined dense class="modern-input" prepend-inner-icon="fas fa-map-marker-alt"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Teléfono</div>
                    <v-text-field v-model='phone' outlined dense class="modern-input" prepend-inner-icon="fas fa-phone"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Correo Electrónico</div>
                    <v-text-field v-model='email' outlined dense class="modern-input" prepend-inner-icon="fas fa-envelope"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Sitio Web</div>
                    <v-text-field v-model='webpage' outlined dense class="modern-input" prepend-inner-icon="fas fa-globe"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>

              <!-- Logo Section -->
              <v-col cols="12" md="4">
                <v-card outlined class="pa-6 rounded-lg bg-lightgrey border-dashed text-center h-100 d-flex flex-column align-center justify-center">
                  <div class="caption font-weight-black grey--text text-uppercase mb-4">Logo Corporativo</div>
                  
                  <div class="position-relative d-inline-block logo-wrapper">
                    <!-- Preview Avatar with Hover Overlay -->
                    <v-hover v-slot="{ hover }">
                      <v-avatar 
                        size="180" tile color="white" 
                        class="shadow-sm rounded-xl mb-2 overflow-hidden border pointer-cursor logo-avatar"
                        @click="$refs.logoInput.$refs.input.click()"
                      >
                        <v-img :src='logoFile ? url : logo' contain>
                          <v-fade-transition>
                            <div
                              v-if="hover"
                              class="d-flex transition-fast-in-fast-out secondary darken-1 v-card--reveal text-h2 white--text"
                              style="height: 100%; width: 100%; position: absolute; bottom: 0; opacity: 0.9; cursor: pointer;"
                            >
                              <div class="d-flex flex-column align-center justify-center w-100 h-100">
                                <v-icon color="white" large>fas fa-camera</v-icon>
                                <span class="caption font-weight-black mt-2 text-uppercase">Cambiar Imagen</span>
                              </div>
                            </div>
                          </v-fade-transition>
                        </v-img>
                      </v-avatar>
                    </v-hover>
                    
                    <!-- Floating Cancel Button for pending file -->
                    <v-fade-transition>
                      <v-btn
                        v-if="logoFile"
                        fab x-small
                        color="error"
                        class="logo-cancel-btn shadow-sm"
                        @click.stop="cancelLogoSelection"
                      >
                        <v-icon x-small>fas fa-times</v-icon>
                      </v-btn>
                    </v-fade-transition>

                    <!-- Small Camera Indicator (Always visible if no hover) -->
                    <div class="logo-indicator shadow-sm d-flex align-center justify-center">
                      <v-icon x-small color="white">fas fa-camera</v-icon>
                    </div>
                  </div>

                  <!-- Hidden File Input -->
                  <v-file-input 
                    ref="logoInput"
                    v-model="logoFile" 
                    accept="image/*" 
                    class="d-none"
                    @change="onFileChange"
                  ></v-file-input>

                  <div class="caption mt-4 grey--text font-weight-bold italic px-4 lh-1-2">
                    Haz click sobre la imagen para cargar un nuevo logo corporativo
                  </div>
                  <div class="caption mt-1 grey--text opacity-60">PNG o JPG (Max 2MB)</div>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- 2. Documents Settings -->
          <v-tab-item class="pa-8">
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex align-center mb-6">
                  <v-avatar size="32" color="secondary lighten-5" class="mr-3">
                    <v-icon color="secondary" small>fas fa-shopping-cart</v-icon>
                  </v-avatar>
                  <span class="text-h6 font-weight-black secondary--text">Órdenes de Compra (OC)</span>
                </div>
                <v-card outlined class="pa-6 rounded-lg border-light">
                  <v-row dense>
                    <v-col cols="12">
                      <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Monto Límite para Aprobación Automática</div>
                      <v-text-field v-model="po_approve_limit" type="number" outlined dense prepend-inner-icon="fas fa-lock" class="modern-input" suffix="CLP"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Moneda por Defecto OC</div>
                      <v-text-field v-model="default_currency" outlined dense class="modern-input" placeholder="Ej: CLP"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">{{ internacional.purchase_tax_label }} OC (%)</div>
                      <v-text-field v-model="tax" type="number" outlined dense class="modern-input" suffix="%"></v-text-field>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>

              <v-col cols="12" md="6">
                <div class="d-flex align-center mb-6">
                  <v-avatar size="32" color="orange lighten-5" class="mr-3">
                    <v-icon color="orange darken-3" small>fas fa-file-signature</v-icon>
                  </v-avatar>
                  <span class="text-h6 font-weight-black grey--text text--darken-3">Cotizaciones (CN)</span>
                </div>
                <v-card outlined class="pa-6 rounded-lg border-light">
                  <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Texto Fijo en Documento</div>
                  <v-textarea v-model="fixed_text_quotation" outlined dense rows="3" class="modern-input" placeholder="Ej: Condiciones comerciales, plazos de entrega..."></v-textarea>
                  
                  <v-sheet outlined class="pa-4 rounded-lg bg-lightgrey border-dashed d-flex align-center mt-2">
                    <v-checkbox v-model="show_product_size_quotation" hide-details class="mt-0 pt-0"></v-checkbox>
                    <div>
                      <div class="body-2 font-weight-black primary--text">Mostrar Medidas de Productos</div>
                      <div class="caption grey--text">Incluye largo, ancho y fuelle en el PDF generado</div>
                    </div>
                  </v-sheet>

                  <v-sheet outlined class="pa-4 rounded-lg bg-lightgrey border-dashed d-flex align-center mt-4">
                    <v-checkbox v-model="show_contact_data_quotation" hide-details class="mt-0 pt-0"></v-checkbox>
                    <div>
                      <div class="body-2 font-weight-black primary--text">Mostrar Datos de Contacto</div>
                      <div class="caption grey--text">Incluye los datos de contacto en el PDF de la cotización</div>
                    </div>
                  </v-sheet>

                  <v-sheet outlined class="pa-4 rounded-lg bg-lightgrey border-dashed d-flex align-center mt-4">
                    <v-checkbox v-model="exclude_reposicion_from_invoicing" hide-details class="mt-0 pt-0"></v-checkbox>
                    <div>
                      <div class="body-2 font-weight-black primary--text">Excluir Reposiciones del Capital Retenido</div>
                      <div class="caption grey--text">Las cotizaciones marcadas como reposición no se consideran en los informes de capital retenido ni en los correos de gerencia y recordatorio a vendedores</div>
                    </div>
                  </v-sheet>

                  <v-sheet outlined class="pa-4 rounded-lg bg-lightgrey border-dashed d-flex align-center mt-4">
                    <v-checkbox v-model="exclude_zero_total_from_invoicing" hide-details class="mt-0 pt-0"></v-checkbox>
                    <div>
                      <div class="body-2 font-weight-black primary--text">Excluir OT con Total $0 del Capital Retenido</div>
                      <div class="caption grey--text">Las órdenes de trabajo con monto total en cero no se consideran en los informes de capital retenido ni en los correos de gerencia y recordatorio a vendedores</div>
                    </div>
                  </v-sheet>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- 3. Production -->
          <v-tab-item class="pa-8">
            <div class="d-flex align-center mb-6">
              <v-avatar size="32" color="blue lighten-5" class="mr-3">
                <v-icon color="blue" small>fas fa-cogs</v-icon>
              </v-avatar>
              <span class="text-h6 font-weight-black primary--text">Flujos de Producción e Inventario</span>
            </div>
            
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex flex-column" style="gap: 16px;">
                  <v-sheet outlined class="pa-4 rounded-lg bg-lightgrey border-dashed d-flex align-center">
                    <v-checkbox v-model="preproduction_active" hide-details class="mt-0 pt-0"></v-checkbox>
                    <div class="ml-2">
                      <div class="body-2 font-weight-black primary--text uppercase tracking-tighter">Activar Etapa de Pre-Producción</div>
                      <div class="caption grey--text">Añade validación técnica previa antes de liberar a planta</div>
                    </div>
                  </v-sheet>
                  
                  <v-sheet outlined class="pa-4 rounded-lg bg-lightgrey border-dashed d-flex align-center">
                    <v-checkbox v-model="complete_ot_without_logistics" hide-details class="mt-0 pt-0"></v-checkbox>
                    <div class="ml-2">
                      <div class="body-2 font-weight-black primary--text uppercase tracking-tighter">Cierre de OT Simplificado</div>
                      <div class="caption grey--text">Permite completar órdenes sin requerir despacho logístico</div>
                    </div>
                  </v-sheet>

                  <v-sheet outlined class="pa-4 rounded-lg bg-lightgrey border-dashed d-flex align-center">
                    <v-checkbox v-model="load_planner_on_initial" hide-details class="mt-0 pt-0"></v-checkbox>
                    <div class="ml-2">
                      <div class="body-2 font-weight-black primary--text uppercase tracking-tighter">Auto-carga de Planificador</div>
                      <div class="caption grey--text">Carga automáticamente la data del planificador al entrar al módulo</div>
                    </div>
                  </v-sheet>

                  <v-sheet outlined class="pa-4 rounded-lg bg-lightgrey border-dashed d-flex align-center">
                    <v-checkbox v-model="show_contact_data_workorder" hide-details class="mt-0 pt-0"></v-checkbox>
                    <div class="ml-2">
                      <div class="body-2 font-weight-black primary--text uppercase tracking-tighter">Mostrar Datos de Contacto en OT</div>
                      <div class="caption grey--text">Incluye los datos de contacto en el documento de la orden de trabajo</div>
                    </div>
                  </v-sheet>
                </div>
              </v-col>

              <v-col cols="12" md="6">
                <v-card outlined class="pa-6 rounded-lg bg-lightgrey border-light">
                  <div class="d-flex align-center mb-4">
                    <v-checkbox v-model="stock_validation_active" hide-details class="mt-0 pt-0"></v-checkbox>
                    <div class="ml-2">
                      <div class="body-2 font-weight-black primary--text uppercase tracking-tighter">Alerta de Stock Insuficiente en OT</div>
                      <div class="caption grey--text">Notifica por correo cuando la OT requiere más insumos de los disponibles</div>
                    </div>
                  </div>
                  <v-expand-transition>
                    <div v-show="stock_validation_active">
                      <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Lista de Notificación (Email)</div>
                      <v-textarea v-model="stock_validation_email_list" outlined dense rows="3" class="modern-input-white" placeholder="bodega@empresa.com, operaciones@empresa.com"></v-textarea>
                      <div class="caption grey--text mt-1"><v-icon x-small class="mr-1">fas fa-info-circle</v-icon> Separar correos mediante comas (también configurable en la pestaña Notificaciones)</div>
                    </div>
                  </v-expand-transition>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- 4. Dashboard -->
          <v-tab-item class="pa-8">
            <div class="d-flex align-center mb-6">
              <v-avatar size="32" color="purple lighten-5" class="mr-3">
                <v-icon color="purple" small>fas fa-th-large</v-icon>
              </v-avatar>
              <span class="text-h6 font-weight-black grey--text text--darken-3">Visibilidad del Dashboard Principal</span>
            </div>
            
            <v-row>
              <v-col cols="12">
                <v-card outlined class="pa-6 rounded-lg bg-lightgrey">
                  <div class="caption font-weight-black grey--text text-uppercase mb-4 px-2">Tarjetas de Resumen Habilitadas</div>
                  <v-row dense>
                    <v-col cols="12" sm="6" md="3">
                      <v-checkbox v-model="dashboard_card_quoted" label="Cotizado" dense class="modern-checkbox"></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-checkbox v-model="dashboard_card_confirmed" label="Confirmado" dense class="modern-checkbox"></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-checkbox v-model="dashboard_card_confirmed_finished" label="Finalizado" dense class="modern-checkbox"></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-checkbox v-model="dashboard_card_confirmed_finished_not_invoiced" label="Fin. No Facturado" dense class="modern-checkbox"></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-checkbox v-model="dashboard_card_invoiced" label="Facturado" dense class="modern-checkbox"></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-checkbox v-model="dashboard_card_paid" label="Pagado" dense class="modern-checkbox"></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-checkbox v-model="dashboard_card_purchase_subtotal" label="Compras Neto" dense class="modern-checkbox"></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-checkbox v-model="dashboard_card_purchase_paid" label="Compras Pagado" dense class="modern-checkbox"></v-checkbox>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- 5. System -->
          <v-tab-item class="pa-8">
            <v-row>
              <v-col cols="12" md="7">
                <div class="d-flex align-center mb-6">
                  <v-avatar size="32" color="primary lighten-5" class="mr-3">
                    <v-icon color="primary" small>fas fa-envelope-open-text</v-icon>
                  </v-avatar>
                  <span class="text-h6 font-weight-black primary--text">Servidor de Correos (SMTP)</span>
                </div>
                <v-card outlined class="pa-6 rounded-lg border-light shadow-sm">
                  <v-row dense>
                    <v-col cols="12" md="8">
                      <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Servidor (Host)</div>
                      <v-text-field @change="()=>email_tested=false" v-model='email_host' outlined dense class="modern-input"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Puerto</div>
                      <v-text-field @change="()=>email_tested=false" v-model='email_port' outlined dense class="modern-input"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Usuario / Email de Envío</div>
                      <v-text-field @change="()=>email_tested=false" v-model='email_user' outlined dense class="modern-input" prepend-inner-icon="fas fa-user"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Contraseña</div>
                      <v-text-field @change="()=>email_tested=false" v-model='email_password' type="password" outlined dense class="modern-input" prepend-inner-icon="fas fa-key" placeholder="•••••• (dejar en blanco para mantener la actual)"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Nombre Remitente</div>
                      <v-text-field @change="()=>email_tested=false" v-model='email_from' outlined dense class="modern-input" placeholder="Ej: Runflow Notificaciones"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Encriptación</div>
                      <v-select 
                        @change="()=>email_tested=false" 
                        v-model="email_smtp_encryption"
                        outlined dense
                        :items="[{text:'SSL (Secure)',value:'ssl'},{text:'TLS (Default)',value:'tls'}]"
                        class="modern-input"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-divider class="my-4"></v-divider>
                  <div class="caption grey--text mb-2" v-if="!email_password">
                    <v-icon x-small class="mr-1">fas fa-info-circle</v-icon>
                    Por seguridad la contraseña guardada no se muestra. Para probar la conexión, escríbala nuevamente.
                  </div>
                  <div class="d-flex justify-end">
                    <email-test
                      v-model="email_tested"
                      :email_host="email_host"
                      :email_user="email_user"
                      :email_password="email_password"
                      :email_port="email_port"
                      :email_smtp_encryption="email_smtp_encryption"
                      :email_from="email_from"
                    />
                  </div>
                </v-card>
              </v-col>

              <v-col cols="12" md="5">
                <div class="d-flex align-center mb-6">
                  <v-avatar size="32" color="secondary lighten-5" class="mr-3">
                    <v-icon color="secondary" small>fas fa-plug</v-icon>
                  </v-avatar>
                  <span class="text-h6 font-weight-black secondary--text">Integraciones Externas</span>
                </div>
                <v-card outlined class="pa-6 rounded-lg bg-lightgrey text-center py-10">
                  <v-avatar size="64" color="white" class="shadow-sm mb-4">
                    <v-icon color="secondary" large>fas fa-file-invoice</v-icon>
                  </v-avatar>
                  <div class="text-h6 font-weight-black primary--text lh-1-2">Factrónica</div>
                  <div class="caption grey--text mb-6">Emisión de documentos electrónicos integrados</div>
                  
                  <v-btn 
                    :color="factronica_integration_activated ? 'success' : 'grey lighten-2'" 
                    class="rounded-lg text-none px-8 shadow-xs"
                    depressed
                    @click="factronica_integration_activated = !factronica_integration_activated"
                  >
                    <v-icon left small>fas fa-power-off</v-icon>
                    {{ factronica_integration_activated ? 'ACTIVADO' : 'DESACTIVADO' }}
                  </v-btn>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- 6. Notificaciones -->
          <v-tab-item class="pa-8">
            <div class="d-flex align-center justify-space-between mb-6 flex-wrap" style="gap: 12px;">
              <div class="d-flex align-center">
                <v-avatar size="36" color="primary lighten-5" class="mr-3">
                  <v-icon color="primary" small>fas fa-bell</v-icon>
                </v-avatar>
                <div>
                  <div class="text-h6 font-weight-black primary--text lh-1">Centro de Notificaciones y Recordatorios</div>
                  <div class="caption grey--text mt-1">Configura las alertas automáticas del sistema, horarios y destinatarios</div>
                </div>
              </div>

              <v-chip outlined color="primary" class="font-weight-bold">
                <v-icon left x-small color="primary">fas fa-globe</v-icon>
                Zona Horaria: {{ current_time_zone || 'America/Santiago' }}
              </v-chip>
            </div>

            <!-- Módulo 1: Recordatorio de Facturación -->
            <v-card outlined class="pa-4 rounded-lg border-light shadow-sm mb-3">
              <div class="d-flex align-center w-100">
                <v-avatar size="28" color="primary lighten-5" class="mr-2">
                  <v-icon color="primary" x-small>fas fa-file-invoice-dollar</v-icon>
                </v-avatar>
                <div>
                  <div class="body-2 font-weight-black primary--text">Recordatorio de Facturación (OT)</div>
                  <div class="caption grey--text">{{ invoicingReminderSummary }}</div>
                </div>
                <v-spacer></v-spacer>
                <v-switch
                  v-model="invoicing_reminder_active"
                  hide-details
                  dense
                  class="mt-0 pt-0"
                  color="success"
                ></v-switch>
                <v-chip
                  x-small
                  :color="invoicing_reminder_active ? 'success lighten-5' : 'grey lighten-3'"
                  :class="invoicing_reminder_active ? 'success--text font-weight-bold ml-2' : 'grey--text text--darken-1 font-weight-bold ml-2'"
                >
                  {{ invoicing_reminder_active ? 'ACTIVO' : 'INACTIVO' }}
                </v-chip>
              </div>

              <v-expand-transition>
                <div v-show="invoicing_reminder_active">
                  <v-divider class="my-3"></v-divider>

                  <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Correo(s) del Gerente (Resumen Consolidado)</div>
                  <v-textarea
                    v-model="invoicing_reminder_manager_emails"
                    outlined dense rows="2"
                    class="modern-input-white"
                    placeholder="gerente@empresa.com, gerencia@empresa.com"
                  ></v-textarea>
                  <div class="caption grey--text mt-1 mb-4">
                    Separar correos mediante comas. A cada vendedor le llegará su propio listado.
                  </div>

                  <div class="d-flex flex-wrap" style="gap: 20px;">
                    <div style="width: 110px;">
                      <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Días mínimos</div>
                      <v-text-field
                        v-model.number="invoicing_reminder_min_days"
                        type="number"
                        min="0"
                        outlined dense
                        class="modern-input"
                        suffix="días"
                      ></v-text-field>
                    </div>
                    <div style="width: 170px;">
                      <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Fecha de Inicio</div>
                      <v-text-field
                        v-model="invoicing_reminder_start_date"
                        type="date"
                        outlined dense
                        class="modern-input"
                      ></v-text-field>
                    </div>
                    <div style="width: 130px;">
                      <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Hora de Envío</div>
                      <v-select
                        v-model="invoicing_reminder_time"
                        :items="hourOptions"
                        outlined dense
                        class="modern-input"
                      ></v-select>
                    </div>
                  </div>
                  <div class="caption grey--text mt-1 mb-4">
                    Días mínimos finalizada sin facturar, fecha desde la que se consideran OTs, y hora en punto de envío (zona horaria <strong>{{ current_time_zone || 'America/Santiago' }}</strong>).
                  </div>

                  <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Días de Envío</div>
                  <v-chip-group v-model="invoicing_reminder_weekdays" multiple active-class="primary--text">
                    <v-chip v-for="day in weekdayOptions" :key="day.value" :value="day.value" outlined filter small>
                      {{ day.text }}
                    </v-chip>
                  </v-chip-group>
                </div>
              </v-expand-transition>
            </v-card>

            <!-- Módulo 2: Alerta de Stock Insuficiente en OT -->
            <v-card outlined class="pa-4 rounded-lg border-light shadow-sm">
              <div class="d-flex align-center w-100">
                <v-avatar size="28" color="warning lighten-5" class="mr-2">
                  <v-icon color="warning darken-2" x-small>fas fa-boxes</v-icon>
                </v-avatar>
                <div>
                  <div class="body-2 font-weight-black grey--text text--darken-3">Alerta de Stock Insuficiente en OT</div>
                  <div class="caption grey--text">Notifica por correo cuando una OT supera el stock disponible</div>
                </div>
                <v-spacer></v-spacer>
                <v-switch
                  v-model="stock_validation_active"
                  hide-details
                  dense
                  class="mt-0 pt-0"
                  color="warning darken-2"
                ></v-switch>
                <v-chip
                  x-small
                  :color="stock_validation_active ? 'warning lighten-5' : 'grey lighten-3'"
                  :class="stock_validation_active ? 'warning--text text--darken-3 font-weight-bold ml-2' : 'grey--text text--darken-1 font-weight-bold ml-2'"
                >
                  {{ stock_validation_active ? 'ACTIVO' : 'INACTIVO' }}
                </v-chip>
              </div>

              <v-expand-transition>
                <div v-show="stock_validation_active">
                  <v-divider class="my-3"></v-divider>
                  <div class="caption font-weight-black grey--text text-uppercase mb-1 ml-1">Correo(s) de Destino para la Alerta</div>
                  <v-textarea
                    v-model="stock_validation_email_list"
                    outlined dense rows="2"
                    class="modern-input-white"
                    placeholder="bodega@empresa.com, operaciones@empresa.com"
                  ></v-textarea>
                  <div class="caption grey--text mt-1">
                    Separar múltiples direcciones de correo mediante comas.
                  </div>
                </div>
              </v-expand-transition>
            </v-card>
          </v-tab-item>
        </v-tabs-items>

        <!-- Fixed Footer Actions -->
        <v-sheet color="white" class="pa-6 border-top d-flex justify-end shadow-lg" style="position: sticky; bottom: 0; z-index: 5;">
          <v-btn large color="primary" type="submit" :loading="loading" class="rounded-xl px-12 font-weight-black shadow-sm h-12">
            <v-icon left>fas fa-save</v-icon> Guardar Cambios Globales
          </v-btn>
        </v-sheet>
      </v-form>
    </ValidationObserver>
  </div>
</template>

<script>
import { fetchCompany, updateCompany } from '@/api/parameters'
import notifications from '@/utils/notifications'
import EmailTest from './EmailTest.vue'

export default {
  name: 'Company',
  components: { EmailTest },
  data: () => ({
    tab: 0,
    rut: '',
    name: '',
    giro: '',
    fantasy: '',
    address: '',
    phone: '',
    email: '',
    webpage: '',
    logo: '',
    logoFile: null,
    url: '',
    po_approve_limit: 0,
    default_currency: '',
    tax: 0,
    preproduction_active: false,
    dashboard_card_quoted: true,
    dashboard_card_confirmed: true,
    dashboard_card_confirmed_finished: true,
    dashboard_card_invoiced: true,
    dashboard_card_paid: true,
    dashboard_card_confirmed_finished_not_invoiced: false,
    dashboard_card_purchase_subtotal: true,
    dashboard_card_purchase_paid: true,
    complete_ot_without_logistics: false,
    fixed_text_quotation: '',
    exclude_reposicion_from_invoicing: false,
    exclude_zero_total_from_invoicing: false,
    factronica_integration_activated: false,
    load_planner_on_initial: false,
    stock_validation_active: false,
    stock_validation_email_list: '',
    email_host: '',
    email_user: '',
    email_password: '',
    email_port: '',
    email_smtp_encryption: 'tls',
    email_tested: false,
    email_from: '',
    show_product_size_quotation: false,
    show_contact_data_quotation: false,
    show_contact_data_workorder: false,
    invoicing_reminder_active: false,
    invoicing_reminder_manager_emails: '',
    invoicing_reminder_min_days: 0,
    invoicing_reminder_max_days: 365,
    invoicing_reminder_start_date: '',
    invoicing_reminder_weekdays: [],
    invoicing_reminder_time: '08:00',


    current_time_zone: '',
    loading: false
  }),
  computed: {
    internacional() {
      return this.$store.getters.getInternational || { tax_id_label: 'RUT', purchase_tax_label: 'IVA' }
    },
    weekdayOptions() {
      // value = date.weekday() de Python: 0=Lunes ... 6=Domingo
      return [
        { text: 'Lun', value: 0 },
        { text: 'Mar', value: 1 },
        { text: 'Mié', value: 2 },
        { text: 'Jue', value: 3 },
        { text: 'Vie', value: 4 },
        { text: 'Sáb', value: 5 },
        { text: 'Dom', value: 6 },
      ]
    },
    hourOptions() {
      // Solo horas en punto: el cron evalúa cada hora, los minutos no tienen efecto real.
      return Array.from({ length: 24 }, (_, h) => {
        const label = String(h).padStart(2, '0') + ':00'
        return { text: label, value: label }
      })
    },
    invoicingReminderSummary() {
      if (!this.invoicing_reminder_active) return 'Desactivado'
      const days = (this.invoicing_reminder_weekdays || [])
        .map(val => (this.weekdayOptions.find(d => d.value === val) || {}).text)
        .filter(Boolean)
        .join(', ')
      const time = this.invoicing_reminder_time || '08:00'
      return days ? `${days} a las ${time} hrs` : `A las ${time} hrs (sin días seleccionados)`
    }
  },
  methods: {
    async submit() {
      this.loading = true
      var formData = new FormData()
      formData.append('rut', this.rut || '')
      formData.append('name', this.name || '')
      formData.append('fantasy', this.fantasy || '')
      formData.append('giro', this.giro || '')
      formData.append('address', this.address || '')
      formData.append('phone', this.phone || '')
      formData.append('email', this.email || '')
      formData.append('webpage', this.webpage || '')
      formData.append('stocks_po_approve_limit', this.po_approve_limit || 0)
      formData.append('default_currency', this.default_currency || '')
      formData.append('tax', this.tax || 0)
      formData.append('preproduction_active', this.preproduction_active)
      formData.append('dashboard_card_quoted', this.dashboard_card_quoted)
      formData.append('dashboard_card_confirmed', this.dashboard_card_confirmed)
      formData.append('dashboard_card_confirmed_finished', this.dashboard_card_confirmed_finished)
      formData.append('dashboard_card_invoiced', this.dashboard_card_invoiced)
      formData.append('dashboard_card_paid', this.dashboard_card_paid)
      formData.append('dashboard_card_confirmed_finished_not_invoiced', this.dashboard_card_confirmed_finished_not_invoiced)
      formData.append('dashboard_card_purchase_subtotal', this.dashboard_card_purchase_subtotal)
      formData.append('dashboard_card_purchase_paid', this.dashboard_card_purchase_paid)
      formData.append('complete_ot_without_logistics', this.complete_ot_without_logistics)
      formData.append('fixed_text_quotation', this.fixed_text_quotation || '')
      formData.append('exclude_reposicion_from_invoicing', this.exclude_reposicion_from_invoicing)
      formData.append('exclude_zero_total_from_invoicing', this.exclude_zero_total_from_invoicing)
      formData.append('factronica_integration_activated', this.factronica_integration_activated)
      formData.append('load_planner_on_initial', this.load_planner_on_initial)
      formData.append('stock_validation_active', this.stock_validation_active)
      formData.append('stock_validation_email_list', this.stock_validation_email_list || '')
      
      const cleanEmail = (val) => val ? val.trim().replace(/\s+/g, '') : ''
      formData.append('email_host', cleanEmail(this.email_host))
      formData.append('email_user', cleanEmail(this.email_user))
      // Solo se envía si el usuario escribió una nueva; en blanco mantiene la guardada
      if (this.email_password) formData.append('email_password', this.email_password)
      formData.append('email_port', cleanEmail(this.email_port))
      formData.append('email_smtp_encryption', this.email_smtp_encryption)
      formData.append('email_from', cleanEmail(this.email_from))
      formData.append('show_product_size_quotation', this.show_product_size_quotation)
      formData.append('show_contact_data_quotation', this.show_contact_data_quotation)
      formData.append('show_contact_data_workorder', this.show_contact_data_workorder)
      formData.append('invoicing_reminder_active', this.invoicing_reminder_active)
      formData.append('invoicing_reminder_manager_emails', this.invoicing_reminder_manager_emails || '')
      formData.append('invoicing_reminder_min_days', this.invoicing_reminder_min_days || 0)
      formData.append('invoicing_reminder_max_days', this.invoicing_reminder_max_days !== null && this.invoicing_reminder_max_days !== undefined ? this.invoicing_reminder_max_days : 365)
      formData.append('invoicing_reminder_start_date', this.invoicing_reminder_start_date || '')
      formData.append('invoicing_reminder_weekdays', JSON.stringify(this.invoicing_reminder_weekdays || []))
      formData.append('invoicing_reminder_time', this.invoicing_reminder_time || '08:00')



      if (this.logoFile) formData.append('logo', this.logoFile)

      try {
        await updateCompany(this.rut, formData)
        notifications.showSuccess('Configuración Global Actualizada')
        this.$store.dispatch('getParameters')
      } catch (e) {
        notifications.showError('Error al guardar configuración: ' + e)
      } finally {
        this.loading = false
      }
    },
    onFileChange() {
      if (this.logoFile) this.url = URL.createObjectURL(this.logoFile)
      else this.url = ''
    },
    cancelLogoSelection() {
      this.logoFile = null
      this.url = ''
    }
  },
  async created() {
    try {
      const res = await fetchCompany()
      if (res && res.rut) {
        this.rut = res.rut
        this.name = res.name
        this.fantasy = res.fantasy
        this.giro = res.giro
        this.address = res.address
        this.phone = res.phone
        this.email = res.email
        this.webpage = res.webpage
        this.logo = res.logo_url
        this.po_approve_limit = res.stocks_po_approve_limit
        this.default_currency = res.default_currency
        this.tax = res.tax
        this.preproduction_active = res.preproduction_active
        this.dashboard_card_quoted = res.dashboard_card_quoted
        this.dashboard_card_confirmed = res.dashboard_card_confirmed
        this.dashboard_card_confirmed_finished = res.dashboard_card_confirmed_finished
        this.dashboard_card_invoiced = res.dashboard_card_invoiced
        this.dashboard_card_paid = res.dashboard_card_paid
        this.dashboard_card_confirmed_finished_not_invoiced = res.dashboard_card_confirmed_finished_not_invoiced
        this.dashboard_card_purchase_subtotal = res.dashboard_card_purchase_subtotal
        this.dashboard_card_purchase_paid = res.dashboard_card_purchase_paid
        this.complete_ot_without_logistics = res.complete_ot_without_logistics
        this.fixed_text_quotation = res.fixed_text_quotation
        this.exclude_reposicion_from_invoicing = res.exclude_reposicion_from_invoicing
        this.exclude_zero_total_from_invoicing = res.exclude_zero_total_from_invoicing
        this.factronica_integration_activated = res.factronica_integration_activated
        this.load_planner_on_initial = res.load_planner_on_initial
        this.stock_validation_active = res.stock_validation_active
        this.stock_validation_email_list = res.stock_validation_email_list
        this.email_host = res.email_host
        this.email_user = res.email_user
        // email_password nunca viaja desde el backend (write-only); queda vacío hasta que se escriba una nueva
        this.email_port = res.email_port
        this.email_smtp_encryption = res.email_smtp_encryption
        this.email_from = res.email_from
        this.show_product_size_quotation = res.show_product_size_quotation
        this.show_contact_data_quotation = res.show_contact_data_quotation
        this.show_contact_data_workorder = res.show_contact_data_workorder
        this.invoicing_reminder_active = res.invoicing_reminder_active
        this.invoicing_reminder_manager_emails = res.invoicing_reminder_manager_emails
        this.invoicing_reminder_min_days = res.invoicing_reminder_min_days
        this.invoicing_reminder_max_days = res.invoicing_reminder_max_days !== undefined && res.invoicing_reminder_max_days !== null ? res.invoicing_reminder_max_days : 365
        this.invoicing_reminder_start_date = res.invoicing_reminder_start_date || ''
        this.invoicing_reminder_weekdays = res.invoicing_reminder_weekdays || []
        this.invoicing_reminder_time = res.invoicing_reminder_time ? res.invoicing_reminder_time.substring(0, 5) : '08:00'


        this.current_time_zone = res.current_time_zone || ''
      }
    } catch (e) {
      console.error(e)
    }
  }
}
</script>

<style scoped>
.modern-tab-content { background-color: white; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.08) !important; }
.border-top { border-top: 1px solid rgba(0,0,0,0.08) !important; }
.border-light { border-color: #edf1f4 !important; }

/* Input Styling */
.modern-input >>> .v-input__control >>> .v-input__slot {
  background-color: #f8fbfc !important;
  border-radius: 8px !important;
}
.modern-input-white >>> .v-input__control >>> .v-input__slot {
  background-color: white !important;
  border-radius: 8px !important;
}

.bg-lightgrey { background-color: #f8fbfc !important; }
.border-dashed { border: 1px dashed #cfd8dc !important; }
.uppercase { text-transform: uppercase; letter-spacing: 1px; }
.tracking-widest { letter-spacing: 2px; }
.tracking-tighter { letter-spacing: -0.5px; }
.lh-1 { line-height: 1 !important; }
.lh-1-2 { line-height: 1.25 !important; }
.shadow-sm { box-shadow: 0 2px 8px rgba(0,0,0,0.05) !important; }
.shadow-lg { box-shadow: 0 -4px 12px rgba(0,0,0,0.05) !important; }
.shadow-xs { box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important; }

.modern-checkbox >>> .v-label {
  font-size: 0.85rem !important;
  font-weight: 600 !important;
  color: #455a64 !important;
}

.opacity-70 { opacity: 0.7; }
.opacity-60 { opacity: 0.6; }
.pointer-cursor { cursor: pointer; }
.position-relative { position: relative !important; }
.w-100 { width: 100% !important; }
.h-100 { height: 100% !important; }

.logo-avatar {
  border: 1px solid rgba(0,0,0,0.05) !important;
  transition: all 0.3s ease;
}
.logo-avatar:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 20px rgba(0,0,0,0.1) !important;
}

.logo-cancel-btn {
  position: absolute !important;
  top: -8px;
  right: -8px;
  z-index: 5;
  border: 2px solid white !important;
}

.logo-indicator {
  position: absolute !important;
  bottom: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  background-color: var(--v-secondary-base);
  border-radius: 50%;
  border: 2px solid white;
  z-index: 3;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}
.text-none { text-transform: none !important; }
.h-12 { height: 48px !important; }
.rounded-xl { border-radius: 24px !important; }
</style>